import React, { useEffect, useState } from "react";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import Select from "../../common/form/select";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import AbasGraficos from "./AbasGraficos";

export default function GraficoAgrupado({ abaAtiva, setAbaAtiva, registro, aguardando, setModoTela, lista, buscarLista, tipoInformacao, setTipoInformacao }) {
    const hoje = new Date();
    const [ano, setAno] = useState(String(hoje.getFullYear()));
    const [mes, setMes] = useState(String(hoje.getMonth() + 1).padStart(2, "0"));
    const isMonth = abaAtiva === "mes";
    const dataInicial = isMonth ? `${ano}-${mes}-01` : `${ano}-01-01`;
    const dataFinal = isMonth ? new Date(Date.UTC(Number(ano), Number(mes), 0)).toISOString().substring(0, 10) : `${ano}-12-31`;

    useEffect(() => {
        if (registro.consumoLeitura && registro.consumoLeitura.id_consumo_integracao) {
            buscarLista({ id_consumo_integracao: registro.consumoLeitura.id_consumo_integracao, dataInicial, dataFinal, tipoInformacao });
        }
    }, [abaAtiva, registro, dataInicial, dataFinal, tipoInformacao]);

    useEffect(() => {
        const chart = montarGraficoAgrupado({ lista, isMonth, tipoInformacao, registro });
        return () => chart.dispose();
    }, [lista, isMonth, tipoInformacao]);

    const anos = [];
    for (let anoOpcao = 2023; anoOpcao <= hoje.getFullYear(); anoOpcao++) anos.push(anoOpcao);
    return (
        <ContentCard style={{ backgroundColor: "#f0f1f5", paddingLeft: 0, width: "100%", maxWidth: "100vw", overflowX: "hidden" }}>
            <ContentCardBody padding="0px">
                <Row style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box", flexWrap: "wrap", padding: "15px 7px 0 15px", backgroundColor: "#fff", overflowX: "hidden" }}>
                    <Row style={{ width: "100%", justifyContent: "flex-end" }}>
                        <Grid cols="12 3 3 3">
                            <Button text="Voltar" type="warning" icon="fa fa-chevron-left" disabled={aguardando} event={() => setModoTela("lista", {})} />
                        </Grid>
                    </Row>
                    <AbasGraficos abaAtiva={abaAtiva} setAbaAtiva={setAbaAtiva} />
                    <Row style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box", flexWrap: "wrap", justifyContent: "center", alignItems: "center", padding: "25px 0" }}>
                        <Select
                            name="tipo-informacao-grafico"
                            label="Selecione o tipo de informação"
                            cols="12 12 4 4"
                            options={[
                                { id: "energia", valor: "Dados de energia (consumo)" },
                                { id: "demanda", valor: "Dados de Demanda Máxima" },
                            ]}
                            value={tipoInformacao}
                            readOnly={aguardando}
                            isClearable={false}
                            onChange={setTipoInformacao}
                        />
                        {isMonth && (
                            <Select
                                name="mes-grafico-consumo"
                                label="Mês"
                                cols="12 12 3 3"
                                options={["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"].map((valor, indice) => ({
                                    id: String(indice + 1).padStart(2, "0"),
                                    valor,
                                }))}
                                value={mes}
                                readOnly={aguardando}
                                isSearchable={false}
                                isClearable={false}
                                onChange={setMes}
                            />
                        )}
                        <Select
                            name="ano-grafico-consumo"
                            label="Ano"
                            cols="12 12 3 3"
                            options={anos.map((anoOpcao) => ({ id: anoOpcao, valor: anoOpcao }))}
                            value={ano}
                            readOnly={aguardando}
                            isSearchable={false}
                            isClearable={false}
                            onChange={setAno}
                        />
                    </Row>
                    <div id="graficoConsumoAgrupado" style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box", height: 500, backgroundColor: "#fff" }} />
                </Row>
            </ContentCardBody>
        </ContentCard>
    );
}

function montarGraficoAgrupado({ lista, isMonth, tipoInformacao, registro }) {
    const exibirEmMobile = window.innerWidth <= 768;
    const elementoGrafico = document.getElementById("graficoConsumoAgrupado");
    const larguraGrafico = elementoGrafico ? elementoGrafico.clientWidth : window.innerWidth;
    const larguraMaximaTooltip = Math.min(260, larguraGrafico - 32);
    am4core.useTheme(am4themes_animated);
    const chart = am4core.create("graficoConsumoAgrupado", am4charts.XYChart);
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico de consumo";
    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    const subtitle = chart.titles.create();
    subtitle.text = "3583609307 - Irrigação - Pivô 10 e 11  - Irrigação - Pivô 10 e 11 - Irrigação - Grupo A - Valdir"//registro.nome_unidade_consumidora;
    subtitle.fontWeight = "bold";
    subtitle.fontSize = window.innerWidth < 1150 ? "0.7rem" : "1rem";
    subtitle.fill = am4core.color("#000");
    subtitle.marginBottom = 10;
    if (exibirEmMobile) {
        subtitle.wrap = true;
        subtitle.maxWidth = larguraGrafico - 16;
        subtitle.textAlign = "middle";
    }

    const title = chart.titles.create();
    title.text = isMonth ? "Gráfico de Consumo por Dia" : "Gráfico de Consumo por Mês";
    title.fontWeight = "bold";
    title.fontSize = window.innerWidth < 1150 ? "0.8rem" : "1.2rem";
    title.fill = am4core.color("#000");
    title.marginBottom = 20;

    const eixoData = chart.xAxes.push(new am4charts.DateAxis());
    eixoData.baseInterval = { timeUnit: isMonth ? "day" : "month", count: 1 };
    eixoData.dateFormats.setKey(isMonth ? "day" : "month", isMonth ? "dd/MM" : "MMM");
    eixoData.renderer.minGridDistance = isMonth ? 28 : 40;

    const eixoValor = chart.yAxes.push(new am4charts.ValueAxis());
    eixoValor.title.text = tipoInformacao === "energia" ? "Energia (kWh)" : "Demanda máxima (kW)";
    eixoValor.extraMax = 0.2;

    const titulo = tipoInformacao === "energia" ? "Energia" : "Demanda";
    const unidadeMedida = tipoInformacao === "energia" ? "kWh" : "kW";
    [
        ["fora_ponta", "fora ponta", "#1bd07c"],
        ["ponta", "ponta", "#d42243"],
        ["reservado", "reservado", "#017acd"],
    ].forEach(([campo, nome, cor]) => {
        const serie = chart.series.push(new am4charts.ColumnSeries());
        serie.dataFields.dateX = "data_hora";
        serie.dataFields.valueY = campo;
        serie.name = `${titulo} ${nome} (${unidadeMedida})`;
        serie.fill = am4core.color(cor);
        serie.stroke = am4core.color(cor);
        serie.columns.template.width = am4core.percent(70);
        serie.tooltipText = exibirEmMobile
            ? `${serie.name}:\n[bold]{valueY.formatNumber("###,###,###,###.00")} ${unidadeMedida}[/]`
            : `${serie.name}: [bold]{valueY.formatNumber("###,###,###,###.00")} ${unidadeMedida}[/]`;

        if (exibirEmMobile) {
            // A quebra é definida no tooltipText; wrap pode transformar a quebra explícita em espaço.
            serie.tooltip.label.wrap = false;
            serie.tooltip.label.maxWidth = larguraMaximaTooltip;
            serie.tooltip.label.textAlign = "middle";
        }
    });

    if (tipoInformacao === "demanda") {
        const listaDemandas = lista || [];
        const possuiDemandaForaPontaContratada = listaDemandas.some((item) => item.demanda_fora_ponta_contratada !== null && item.demanda_fora_ponta_contratada !== undefined);
        const modalidadeHorosazonalAzul = listaDemandas.some((item) => Number(item.id_modalidade_tarifaria) === 2);
        const possuiDemandaPontaContratada = listaDemandas.some((item) => item.demanda_ponta_contratada !== null && item.demanda_ponta_contratada !== undefined);

        adicionarLinhaDemandaContratada({
            chart,
            campo: "demanda_fora_ponta_contratada",
            nome: "Demanda contratada fora ponta",
            cor: "#136337",
            espessura: 4,
            exibir: possuiDemandaForaPontaContratada,
            exibirEmMobile,
        });
        adicionarLinhaDemandaContratada({
            chart,
            campo: "demanda_ponta_contratada",
            nome: "Demanda contratada ponta",
            cor: "#b91c1c",
            espessura: 4,
            exibir: modalidadeHorosazonalAzul && possuiDemandaPontaContratada,
            exibirEmMobile,
        });
    }
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color("#000");
    chart.legend.valueLabels.template.fill = am4core.color("#000");
    chart.legend.itemContainers.template.fill = am4core.color("#000");
    chart.cursor = new am4charts.XYCursor();
    chart.data = (lista || []).map((item) => ({ ...item, data_hora: new Date(item.data_hora) }));
    return chart;
}

function adicionarLinhaDemandaContratada({ chart, campo, nome, cor, espessura, exibir, exibirEmMobile }) {
    if (!exibir) return;

    const serie = chart.series.push(new am4charts.LineSeries());
    serie.dataFields.dateX = "data_hora";
    serie.dataFields.valueY = campo;
    serie.name = nome;
    serie.stroke = am4core.color(cor);
    serie.strokeWidth = espessura;
    serie.connect = false;
    serie.tooltip.getFillFromObject = false;
    serie.tooltip.background.fill = serie.stroke;
    serie.tooltip.label.fill = am4core.color("#fff");
    serie.tooltipText = exibirEmMobile
        ? `${nome}:\n[bold]{valueY.formatNumber("###,###,###,###.00")} kW[/]`
        : `${nome}: [bold]{valueY.formatNumber("###,###,###,###.00")} kW[/]`;
}
